import { render } from "./VsIcon.vue?vue&type=template&id=1dd1cbaa"
import script from "./VsIcon.vue?vue&type=script&lang=js"
export * from "./VsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__